import { createContext } from 'react'

import { EMPTY_OBJECT } from '../../constants/common'

export const FieldVariableContext = createContext(EMPTY_OBJECT)
